import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteRight, FaStar } from 'react-icons/fa';

// Import Swiper core and required modules
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css'; 
import 'swiper/css/pagination';



const Testimonials = () => {

  return (
    <section className='testimonials'>

      {/* Section heading */}
      <Heading title={'Customer Testimonials'} subTitle={`What Our Customers Say`} />

      <div className='testimonial-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Pagination, Autoplay]} // Enable Pagination & Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds
          pagination={{ clickable: true }} // Enable pagination dots

          // Responsive Breakpoints
          breakpoints={{
            768: { slidesPerView: 1 }, // 1 slides for tablets
            991: { slidesPerView: 2 }, // 2 slides for larger screens
          }}

        >
          {/* Map over the testiContent array to render each testimonial */}
          {testiContent.map((testimonial) => {

            // Destructure testimonial object
            const { id, image, content, name, title } = testimonial;

            return (
              <SwiperSlide className='testi-item' key={id}>

                <div className='content'>

                  {/* Author Rating */}
                  <div className="rating">
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                  </div>

                  <p>"{content}"</p> {/* Testimonial */}

                </div>

                <div className='bottom'>

                  {/* Author details */}
                  <div className='intro'>
                    <img src={image} alt={name} /> {/* Author image */}
                    <div className='text'>
                      <h4>{name}</h4> {/* Author name */}
                      <h6>{title}</h6> {/* Author title */}
                    </div>
                  </div>

                  <FaQuoteRight className='quote-right' /> {/* Testimonial quote right icon */}

                </div>

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;